import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/assert/contains';
import __var_2__ from '@stdlib/assert/deep-equal';
import __var_3__ from '@stdlib/assert/deep-has-own-property';
import __var_4__ from '@stdlib/assert/deep-has-property';
import __var_5__ from '@stdlib/assert/has-arraybuffer-support';
import __var_6__ from '@stdlib/assert/has-async-await-support';
import __var_7__ from '@stdlib/assert/has-async-iterator-symbol-support';
import __var_8__ from '@stdlib/assert/has-class-support';
import __var_9__ from '@stdlib/assert/has-define-properties-support';
import __var_10__ from '@stdlib/assert/has-define-property-support';
import __var_11__ from '@stdlib/assert/has-float32array-support';
import __var_12__ from '@stdlib/assert/has-float64array-support';
import __var_13__ from '@stdlib/assert/has-function-name-support';
import __var_14__ from '@stdlib/assert/has-generator-support';
import __var_15__ from '@stdlib/assert/has-globalthis-support';
import __var_16__ from '@stdlib/assert/has-int8array-support';
import __var_17__ from '@stdlib/assert/has-int16array-support';
import __var_18__ from '@stdlib/assert/has-int32array-support';
import __var_19__ from '@stdlib/assert/has-iterator-symbol-support';
import __var_20__ from '@stdlib/assert/has-map-support';
import __var_21__ from '@stdlib/assert/has-node-buffer-support';
import __var_22__ from '@stdlib/assert/has-own-property';
import __var_23__ from '@stdlib/assert/has-property';
import __var_24__ from '@stdlib/assert/has-proxy-support';
import __var_25__ from '@stdlib/assert/has-set-support';
import __var_26__ from '@stdlib/assert/has-sharedarraybuffer-support';
import __var_27__ from '@stdlib/assert/has-symbol-support';
import __var_28__ from '@stdlib/assert/has-tostringtag-support';
import __var_29__ from '@stdlib/assert/has-uint8array-support';
import __var_30__ from '@stdlib/assert/has-uint8clampedarray-support';
import __var_31__ from '@stdlib/assert/has-uint16array-support';
import __var_32__ from '@stdlib/assert/has-uint32array-support';
import __var_33__ from '@stdlib/assert/has-utf16-surrogate-pair-at';
import __var_34__ from '@stdlib/assert/has-wasm-support';
import __var_35__ from '@stdlib/assert/has-weakmap-support';
import __var_36__ from '@stdlib/assert/has-weakset-support';
import __var_37__ from '@stdlib/assert/instance-of';
import __var_38__ from '@stdlib/assert/is-absolute-path';
import __var_39__ from '@stdlib/assert/is-accessor-property';
import __var_40__ from '@stdlib/assert/is-accessor-property-in';
import __var_41__ from '@stdlib/assert/is-alphagram';
import __var_42__ from '@stdlib/assert/is-alphanumeric';
import __var_43__ from '@stdlib/assert/is-anagram';
import __var_44__ from '@stdlib/assert/is-arguments';
import __var_45__ from '@stdlib/assert/is-array';
import __var_46__ from '@stdlib/assert/is-array-array';
import __var_47__ from '@stdlib/assert/is-array-length';
import __var_48__ from '@stdlib/assert/is-array-like';
import __var_49__ from '@stdlib/assert/is-array-like-object';
import __var_50__ from '@stdlib/assert/is-arraybuffer';
import __var_51__ from '@stdlib/assert/is-ascii';
import __var_52__ from '@stdlib/assert/is-between';
import __var_53__ from '@stdlib/assert/is-between-array';
import __var_54__ from '@stdlib/assert/is-big-endian';
import __var_55__ from '@stdlib/assert/is-binary-string';
import __var_56__ from '@stdlib/assert/is-boolean';
import __var_57__ from '@stdlib/assert/is-boolean-array';
import __var_58__ from '@stdlib/assert/is-boxed-primitive';
import __var_59__ from '@stdlib/assert/is-browser';
import __var_60__ from '@stdlib/assert/is-buffer';
import __var_61__ from '@stdlib/assert/is-capitalized';
import __var_62__ from '@stdlib/assert/is-centrosymmetric-matrix';
import __var_63__ from '@stdlib/assert/is-circular';
import __var_64__ from '@stdlib/assert/is-circular-array';
import __var_65__ from '@stdlib/assert/is-circular-plain-object';
import __var_66__ from '@stdlib/assert/is-collection';
import __var_67__ from '@stdlib/assert/is-complex';
import __var_68__ from '@stdlib/assert/is-complex-like';
import __var_69__ from '@stdlib/assert/is-complex-typed-array';
import __var_70__ from '@stdlib/assert/is-complex-typed-array-like';
import __var_71__ from '@stdlib/assert/is-complex64';
import __var_72__ from '@stdlib/assert/is-complex64array';
import __var_73__ from '@stdlib/assert/is-complex128';
import __var_74__ from '@stdlib/assert/is-complex128array';
import __var_75__ from '@stdlib/assert/is-composite';
import __var_76__ from '@stdlib/assert/is-configurable-property';
import __var_77__ from '@stdlib/assert/is-configurable-property-in';
import __var_78__ from '@stdlib/assert/is-cube-number';
import __var_79__ from '@stdlib/assert/is-darwin';
import __var_80__ from '@stdlib/assert/is-data-property';
import __var_81__ from '@stdlib/assert/is-data-property-in';
import __var_82__ from '@stdlib/assert/is-date-object';
import __var_83__ from '@stdlib/assert/is-digit-string';
import __var_84__ from '@stdlib/assert/is-electron';
import __var_85__ from '@stdlib/assert/is-electron-main';
import __var_86__ from '@stdlib/assert/is-electron-renderer';
import __var_87__ from '@stdlib/assert/is-email-address';
import __var_88__ from '@stdlib/assert/is-empty-array';
import __var_89__ from '@stdlib/assert/is-empty-object';
import __var_90__ from '@stdlib/assert/is-empty-string';
import __var_91__ from '@stdlib/assert/is-enumerable-property';
import __var_92__ from '@stdlib/assert/is-enumerable-property-in';
import __var_93__ from '@stdlib/assert/is-error';
import __var_94__ from '@stdlib/assert/is-eval-error';
import __var_95__ from '@stdlib/assert/is-even';
import __var_96__ from '@stdlib/assert/is-falsy';
import __var_97__ from '@stdlib/assert/is-falsy-array';
import __var_98__ from '@stdlib/assert/is-finite';
import __var_99__ from '@stdlib/assert/is-finite-array';
import __var_100__ from '@stdlib/assert/is-float32array';
import __var_101__ from '@stdlib/assert/is-float32matrix-like';
import __var_102__ from '@stdlib/assert/is-float32ndarray-like';
import __var_103__ from '@stdlib/assert/is-float32vector-like';
import __var_104__ from '@stdlib/assert/is-float64array';
import __var_105__ from '@stdlib/assert/is-float64matrix-like';
import __var_106__ from '@stdlib/assert/is-float64ndarray-like';
import __var_107__ from '@stdlib/assert/is-float64vector-like';
import __var_108__ from '@stdlib/assert/is-function';
import __var_109__ from '@stdlib/assert/is-function-array';
import __var_110__ from '@stdlib/assert/is-generator-object';
import __var_111__ from '@stdlib/assert/is-generator-object-like';
import __var_112__ from '@stdlib/assert/is-gzip-buffer';
import __var_113__ from '@stdlib/assert/is-hex-string';
import __var_114__ from '@stdlib/assert/is-infinite';
import __var_115__ from '@stdlib/assert/is-inherited-property';
import __var_116__ from '@stdlib/assert/is-int8array';
import __var_117__ from '@stdlib/assert/is-int16array';
import __var_118__ from '@stdlib/assert/is-int32array';
import __var_119__ from '@stdlib/assert/is-integer';
import __var_120__ from '@stdlib/assert/is-integer-array';
import __var_121__ from '@stdlib/assert/is-iterable-like';
import __var_122__ from '@stdlib/assert/is-iterator-like';
import __var_123__ from '@stdlib/assert/is-json';
import __var_124__ from '@stdlib/assert/is-leap-year';
import __var_125__ from '@stdlib/assert/is-little-endian';
import __var_126__ from '@stdlib/assert/is-lowercase';
import __var_127__ from '@stdlib/assert/is-matrix-like';
import __var_128__ from '@stdlib/assert/is-method';
import __var_129__ from '@stdlib/assert/is-method-in';
import __var_130__ from '@stdlib/assert/is-named-typed-tuple-like';
import __var_131__ from '@stdlib/assert/is-nan';
import __var_132__ from '@stdlib/assert/is-nan-array';
import __var_133__ from '@stdlib/assert/is-native-function';
import __var_134__ from '@stdlib/assert/is-ndarray-like';
import __var_135__ from '@stdlib/assert/is-negative-integer';
import __var_136__ from '@stdlib/assert/is-negative-integer-array';
import __var_137__ from '@stdlib/assert/is-negative-number';
import __var_138__ from '@stdlib/assert/is-negative-number-array';
import __var_139__ from '@stdlib/assert/is-negative-zero';
import __var_140__ from '@stdlib/assert/is-node';
import __var_141__ from '@stdlib/assert/is-node-builtin';
import __var_142__ from '@stdlib/assert/is-node-duplex-stream-like';
import __var_143__ from '@stdlib/assert/is-node-readable-stream-like';
import __var_144__ from '@stdlib/assert/is-node-repl';
import __var_145__ from '@stdlib/assert/is-node-stream-like';
import __var_146__ from '@stdlib/assert/is-node-transform-stream-like';
import __var_147__ from '@stdlib/assert/is-node-writable-stream-like';
import __var_148__ from '@stdlib/assert/is-nonconfigurable-property';
import __var_149__ from '@stdlib/assert/is-nonconfigurable-property-in';
import __var_150__ from '@stdlib/assert/is-nonenumerable-property';
import __var_151__ from '@stdlib/assert/is-nonenumerable-property-in';
import __var_152__ from '@stdlib/assert/is-nonnegative-integer';
import __var_153__ from '@stdlib/assert/is-nonnegative-integer-array';
import __var_154__ from '@stdlib/assert/is-nonnegative-number';
import __var_155__ from '@stdlib/assert/is-nonnegative-number-array';
import __var_156__ from '@stdlib/assert/is-nonpositive-integer';
import __var_157__ from '@stdlib/assert/is-nonpositive-integer-array';
import __var_158__ from '@stdlib/assert/is-nonpositive-number';
import __var_159__ from '@stdlib/assert/is-nonpositive-number-array';
import __var_160__ from '@stdlib/assert/is-nonsymmetric-matrix';
import __var_161__ from '@stdlib/assert/is-null';
import __var_162__ from '@stdlib/assert/is-null-array';
import __var_163__ from '@stdlib/assert/is-number';
import __var_164__ from '@stdlib/assert/is-number-array';
import __var_165__ from '@stdlib/assert/is-numeric-array';
import __var_166__ from '@stdlib/assert/is-object';
import __var_167__ from '@stdlib/assert/is-object-array';
import __var_168__ from '@stdlib/assert/is-object-like';
import __var_169__ from '@stdlib/assert/is-odd';
import __var_170__ from '@stdlib/assert/is-persymmetric-matrix';
import __var_171__ from '@stdlib/assert/is-plain-object';
import __var_172__ from '@stdlib/assert/is-plain-object-array';
import __var_173__ from '@stdlib/assert/is-positive-integer';
import __var_174__ from '@stdlib/assert/is-positive-integer-array';
import __var_175__ from '@stdlib/assert/is-positive-number';
import __var_176__ from '@stdlib/assert/is-positive-number-array';
import __var_177__ from '@stdlib/assert/is-positive-zero';
import __var_178__ from '@stdlib/assert/is-prime';
import __var_179__ from '@stdlib/assert/is-primitive';
import __var_180__ from '@stdlib/assert/is-primitive-array';
import __var_181__ from '@stdlib/assert/is-prng-like';
import __var_182__ from '@stdlib/assert/is-probability';
import __var_183__ from '@stdlib/assert/is-probability-array';
import __var_184__ from '@stdlib/assert/is-prototype-of';
import __var_185__ from '@stdlib/assert/is-range-error';
import __var_186__ from '@stdlib/assert/is-read-only-property';
import __var_187__ from '@stdlib/assert/is-read-only-property-in';
import __var_188__ from '@stdlib/assert/is-read-write-property';
import __var_189__ from '@stdlib/assert/is-read-write-property-in';
import __var_190__ from '@stdlib/assert/is-readable-property';
import __var_191__ from '@stdlib/assert/is-readable-property-in';
import __var_192__ from '@stdlib/assert/is-reference-error';
import __var_193__ from '@stdlib/assert/is-regexp';
import __var_194__ from '@stdlib/assert/is-regexp-string';
import __var_195__ from '@stdlib/assert/is-relative-path';
import __var_196__ from '@stdlib/assert/is-safe-integer';
import __var_197__ from '@stdlib/assert/is-safe-integer-array';
import __var_198__ from '@stdlib/assert/is-same-value';
import __var_199__ from '@stdlib/assert/is-same-value-zero';
import __var_200__ from '@stdlib/assert/is-sharedarraybuffer';
import __var_201__ from '@stdlib/assert/is-skew-centrosymmetric-matrix';
import __var_202__ from '@stdlib/assert/is-skew-persymmetric-matrix';
import __var_203__ from '@stdlib/assert/is-skew-symmetric-matrix';
import __var_204__ from '@stdlib/assert/is-square-matrix';
import __var_205__ from '@stdlib/assert/is-square-number';
import __var_206__ from '@stdlib/assert/is-square-triangular-number';
import __var_207__ from '@stdlib/assert/is-strict-equal';
import __var_208__ from '@stdlib/assert/is-string';
import __var_209__ from '@stdlib/assert/is-string-array';
import __var_210__ from '@stdlib/assert/is-symbol';
import __var_211__ from '@stdlib/assert/is-symbol-array';
import __var_212__ from '@stdlib/assert/is-symmetric-matrix';
import __var_213__ from '@stdlib/assert/is-syntax-error';
import __var_214__ from '@stdlib/assert/is-triangular-number';
import __var_215__ from '@stdlib/assert/is-truthy';
import __var_216__ from '@stdlib/assert/is-truthy-array';
import __var_217__ from '@stdlib/assert/is-type-error';
import __var_218__ from '@stdlib/assert/is-typed-array';
import __var_219__ from '@stdlib/assert/is-typed-array-length';
import __var_220__ from '@stdlib/assert/is-typed-array-like';
import __var_221__ from '@stdlib/assert/is-uint8array';
import __var_222__ from '@stdlib/assert/is-uint8clampedarray';
import __var_223__ from '@stdlib/assert/is-uint16array';
import __var_224__ from '@stdlib/assert/is-uint32array';
import __var_225__ from '@stdlib/assert/is-unc-path';
import __var_226__ from '@stdlib/assert/is-undefined';
import __var_227__ from '@stdlib/assert/is-undefined-or-null';
import __var_228__ from '@stdlib/assert/is-unity-probability-array';
import __var_229__ from '@stdlib/assert/is-uppercase';
import __var_230__ from '@stdlib/assert/is-uri';
import __var_231__ from '@stdlib/assert/is-uri-error';
import __var_232__ from '@stdlib/assert/is-vector-like';
import __var_233__ from '@stdlib/assert/is-web-worker';
import __var_234__ from '@stdlib/assert/is-whitespace';
import __var_235__ from '@stdlib/assert/is-windows';
import __var_236__ from '@stdlib/assert/is-writable-property';
import __var_237__ from '@stdlib/assert/is-writable-property-in';
import __var_238__ from '@stdlib/assert/is-write-only-property';
import __var_239__ from '@stdlib/assert/is-write-only-property-in';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name contains
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/contains}
*/
setReadOnly( ns, 'contains', __var_1__);

/**
* @name deepEqual
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/deep-equal}
*/
setReadOnly( ns, 'deepEqual', __var_2__);

/**
* @name deepHasOwnProp
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/deep-has-own-property}
*/
setReadOnly( ns, 'deepHasOwnProp', __var_3__);

/**
* @name deepHasProp
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/deep-has-property}
*/
setReadOnly( ns, 'deepHasProp', __var_4__);

/**
* @name hasArrayBufferSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-arraybuffer-support}
*/
setReadOnly( ns, 'hasArrayBufferSupport', __var_5__);

/**
* @name hasAsyncAwaitSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-async-await-support}
*/
setReadOnly( ns, 'hasAsyncAwaitSupport', __var_6__);

/**
* @name hasAsyncIteratorSymbolSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-async-iterator-symbol-support}
*/
setReadOnly( ns, 'hasAsyncIteratorSymbolSupport', __var_7__);

/**
* @name hasClassSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-class-support}
*/
setReadOnly( ns, 'hasClassSupport', __var_8__);

/**
* @name hasDefinePropertiesSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-define-properties-support}
*/
setReadOnly( ns, 'hasDefinePropertiesSupport', __var_9__);

/**
* @name hasDefinePropertySupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-define-property-support}
*/
setReadOnly( ns, 'hasDefinePropertySupport', __var_10__);

/**
* @name hasFloat32ArraySupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-float32array-support}
*/
setReadOnly( ns, 'hasFloat32ArraySupport', __var_11__);

/**
* @name hasFloat64ArraySupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-float64array-support}
*/
setReadOnly( ns, 'hasFloat64ArraySupport', __var_12__);

/**
* @name hasFunctionNameSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-function-name-support}
*/
setReadOnly( ns, 'hasFunctionNameSupport', __var_13__);

/**
* @name hasGeneratorSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-generator-support}
*/
setReadOnly( ns, 'hasGeneratorSupport', __var_14__);

/**
* @name hasGlobalThisSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-globalthis-support}
*/
setReadOnly( ns, 'hasGlobalThisSupport', __var_15__);

/**
* @name hasInt8ArraySupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-int8array-support}
*/
setReadOnly( ns, 'hasInt8ArraySupport', __var_16__);

/**
* @name hasInt16ArraySupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-int16array-support}
*/
setReadOnly( ns, 'hasInt16ArraySupport', __var_17__);

/**
* @name hasInt32ArraySupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-int32array-support}
*/
setReadOnly( ns, 'hasInt32ArraySupport', __var_18__);

/**
* @name hasIteratorSymbolSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-iterator-symbol-support}
*/
setReadOnly( ns, 'hasIteratorSymbolSupport', __var_19__);

/**
* @name hasMapSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-map-support}
*/
setReadOnly( ns, 'hasMapSupport', __var_20__);

/**
* @name hasNodeBufferSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-node-buffer-support}
*/
setReadOnly( ns, 'hasNodeBufferSupport', __var_21__);

/**
* @name hasOwnProp
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-own-property}
*/
setReadOnly( ns, 'hasOwnProp', __var_22__);

/**
* @name hasProp
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-property}
*/
setReadOnly( ns, 'hasProp', __var_23__);

/**
* @name hasProxySupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-proxy-support}
*/
setReadOnly( ns, 'hasProxySupport', __var_24__);

/**
* @name hasSetSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-set-support}
*/
setReadOnly( ns, 'hasSetSupport', __var_25__);

/**
* @name hasSharedArrayBufferSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-sharedarraybuffer-support}
*/
setReadOnly( ns, 'hasSharedArrayBufferSupport', __var_26__);

/**
* @name hasSymbolSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-symbol-support}
*/
setReadOnly( ns, 'hasSymbolSupport', __var_27__);

/**
* @name hasToStringTagSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-tostringtag-support}
*/
setReadOnly( ns, 'hasToStringTagSupport', __var_28__);

/**
* @name hasUint8ArraySupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-uint8array-support}
*/
setReadOnly( ns, 'hasUint8ArraySupport', __var_29__);

/**
* @name hasUint8ClampedArraySupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-uint8clampedarray-support}
*/
setReadOnly( ns, 'hasUint8ClampedArraySupport', __var_30__);

/**
* @name hasUint16ArraySupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-uint16array-support}
*/
setReadOnly( ns, 'hasUint16ArraySupport', __var_31__);

/**
* @name hasUint32ArraySupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-uint32array-support}
*/
setReadOnly( ns, 'hasUint32ArraySupport', __var_32__);

/**
* @name hasUTF16SurrogatePairAt
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-utf16-surrogate-pair-at}
*/
setReadOnly( ns, 'hasUTF16SurrogatePairAt', __var_33__);

/**
* @name hasWebAssemblySupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-wasm-support}
*/
setReadOnly( ns, 'hasWebAssemblySupport', __var_34__);

/**
* @name hasWeakMapSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-weakmap-support}
*/
setReadOnly( ns, 'hasWeakMapSupport', __var_35__);

/**
* @name hasWeakSetSupport
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/has-weakset-support}
*/
setReadOnly( ns, 'hasWeakSetSupport', __var_36__);

/**
* @name instanceOf
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/instance-of}
*/
setReadOnly( ns, 'instanceOf', __var_37__);

/**
* @name isAbsolutePath
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-absolute-path}
*/
setReadOnly( ns, 'isAbsolutePath', __var_38__);

/**
* @name isAccessorProperty
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-accessor-property}
*/
setReadOnly( ns, 'isAccessorProperty', __var_39__);

/**
* @name isAccessorPropertyIn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-accessor-property-in}
*/
setReadOnly( ns, 'isAccessorPropertyIn', __var_40__);

/**
* @name isAlphagram
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-alphagram}
*/
setReadOnly( ns, 'isAlphagram', __var_41__);

/**
* @name isAlphaNumeric
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-alphanumeric}
*/
setReadOnly( ns, 'isAlphaNumeric', __var_42__);

/**
* @name isAnagram
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-anagram}
*/
setReadOnly( ns, 'isAnagram', __var_43__);

/**
* @name isArguments
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-arguments}
*/
setReadOnly( ns, 'isArguments', __var_44__);

/**
* @name isArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-array}
*/
setReadOnly( ns, 'isArray', __var_45__);

/**
* @name isArrayArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-array-array}
*/
setReadOnly( ns, 'isArrayArray', __var_46__);

/**
* @name isArrayLength
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-array-length}
*/
setReadOnly( ns, 'isArrayLength', __var_47__);

/**
* @name isArrayLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-array-like}
*/
setReadOnly( ns, 'isArrayLike', __var_48__);

/**
* @name isArrayLikeObject
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-array-like-object}
*/
setReadOnly( ns, 'isArrayLikeObject', __var_49__);

/**
* @name isArrayBuffer
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-arraybuffer}
*/
setReadOnly( ns, 'isArrayBuffer', __var_50__);

/**
* @name isASCII
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-ascii}
*/
setReadOnly( ns, 'isASCII', __var_51__);

/**
* @name isBetween
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-between}
*/
setReadOnly( ns, 'isBetween', __var_52__);

/**
* @name isBetweenArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-between-array}
*/
setReadOnly( ns, 'isBetweenArray', __var_53__);

/**
* @name IS_BIG_ENDIAN
* @memberof ns
* @readonly
* @type {boolean}
* @see {@link module:@stdlib/assert/is-big-endian}
*/
setReadOnly( ns, 'IS_BIG_ENDIAN', __var_54__);

/**
* @name isBinaryString
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-binary-string}
*/
setReadOnly( ns, 'isBinaryString', __var_55__);

/**
* @name isBoolean
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-boolean}
*/
setReadOnly( ns, 'isBoolean', __var_56__);

/**
* @name isBooleanArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-boolean-array}
*/
setReadOnly( ns, 'isBooleanArray', __var_57__);

/**
* @name isBoxedPrimitive
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-boxed-primitive}
*/
setReadOnly( ns, 'isBoxedPrimitive', __var_58__);

/**
* @name IS_BROWSER
* @memberof ns
* @readonly
* @type {boolean}
* @see {@link module:@stdlib/assert/is-browser}
*/
setReadOnly( ns, 'IS_BROWSER', __var_59__);

/**
* @name isBuffer
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-buffer}
*/
setReadOnly( ns, 'isBuffer', __var_60__);

/**
* @name isCapitalized
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-capitalized}
*/
setReadOnly( ns, 'isCapitalized', __var_61__);

/**
* @name isCentrosymmetricMatrix
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-centrosymmetric-matrix}
*/
setReadOnly( ns, 'isCentrosymmetricMatrix', __var_62__);

/**
* @name isCircular
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-circular}
*/
setReadOnly( ns, 'isCircular', __var_63__);

/**
* @name isCircularArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-circular-array}
*/
setReadOnly( ns, 'isCircularArray', __var_64__);

/**
* @name isCircularPlainObject
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-circular-plain-object}
*/
setReadOnly( ns, 'isCircularPlainObject', __var_65__);

/**
* @name isCollection
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-collection}
*/
setReadOnly( ns, 'isCollection', __var_66__);

/**
* @name isComplex
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-complex}
*/
setReadOnly( ns, 'isComplex', __var_67__);

/**
* @name isComplexLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-complex-like}
*/
setReadOnly( ns, 'isComplexLike', __var_68__);

/**
* @name isComplexTypedArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-complex-typed-array}
*/
setReadOnly( ns, 'isComplexTypedArray', __var_69__);

/**
* @name isComplexTypedArrayLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-complex-typed-array-like}
*/
setReadOnly( ns, 'isComplexTypedArrayLike', __var_70__);

/**
* @name isComplex64
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-complex64}
*/
setReadOnly( ns, 'isComplex64', __var_71__);

/**
* @name isComplex64Array
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-complex64array}
*/
setReadOnly( ns, 'isComplex64Array', __var_72__);

/**
* @name isComplex128
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-complex128}
*/
setReadOnly( ns, 'isComplex128', __var_73__);

/**
* @name isComplex128Array
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-complex128array}
*/
setReadOnly( ns, 'isComplex128Array', __var_74__);

/**
* @name isComposite
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-composite}
*/
setReadOnly( ns, 'isComposite', __var_75__);

/**
* @name isConfigurableProperty
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-configurable-property}
*/
setReadOnly( ns, 'isConfigurableProperty', __var_76__);

/**
* @name isConfigurablePropertyIn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-configurable-property-in}
*/
setReadOnly( ns, 'isConfigurablePropertyIn', __var_77__);

/**
* @name isCubeNumber
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-cube-number}
*/
setReadOnly( ns, 'isCubeNumber', __var_78__);

/**
* @name IS_DARWIN
* @memberof ns
* @readonly
* @type {boolean}
* @see {@link module:@stdlib/assert/is-darwin}
*/
setReadOnly( ns, 'IS_DARWIN', __var_79__);

/**
* @name isDataProperty
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-data-property}
*/
setReadOnly( ns, 'isDataProperty', __var_80__);

/**
* @name isDataPropertyIn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-data-property-in}
*/
setReadOnly( ns, 'isDataPropertyIn', __var_81__);

/**
* @name isDateObject
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-date-object}
*/
setReadOnly( ns, 'isDateObject', __var_82__);

/**
* @name isDigitString
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-digit-string}
*/
setReadOnly( ns, 'isDigitString', __var_83__);

/**
* @name IS_ELECTRON
* @memberof ns
* @readonly
* @type {boolean}
* @see {@link module:@stdlib/assert/is-electron}
*/
setReadOnly( ns, 'IS_ELECTRON', __var_84__);

/**
* @name IS_ELECTRON_MAIN
* @memberof ns
* @readonly
* @type {boolean}
* @see {@link module:@stdlib/assert/is-electron-main}
*/
setReadOnly( ns, 'IS_ELECTRON_MAIN', __var_85__);

/**
* @name IS_ELECTRON_RENDERER
* @memberof ns
* @readonly
* @type {boolean}
* @see {@link module:@stdlib/assert/is-electron-renderer}
*/
setReadOnly( ns, 'IS_ELECTRON_RENDERER', __var_86__);

/**
* @name isEmailAddress
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-email-address}
*/
setReadOnly( ns, 'isEmailAddress', __var_87__);

/**
* @name isEmptyArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-empty-array}
*/
setReadOnly( ns, 'isEmptyArray', __var_88__);

/**
* @name isEmptyObject
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-empty-object}
*/
setReadOnly( ns, 'isEmptyObject', __var_89__);

/**
* @name isEmptyString
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-empty-string}
*/
setReadOnly( ns, 'isEmptyString', __var_90__);

/**
* @name isEnumerableProperty
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-enumerable-property}
*/
setReadOnly( ns, 'isEnumerableProperty', __var_91__);

/**
* @name isEnumerablePropertyIn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-enumerable-property-in}
*/
setReadOnly( ns, 'isEnumerablePropertyIn', __var_92__);

/**
* @name isError
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-error}
*/
setReadOnly( ns, 'isError', __var_93__);

/**
* @name isEvalError
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-eval-error}
*/
setReadOnly( ns, 'isEvalError', __var_94__);

/**
* @name isEven
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-even}
*/
setReadOnly( ns, 'isEven', __var_95__);

/**
* @name isFalsy
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-falsy}
*/
setReadOnly( ns, 'isFalsy', __var_96__);

/**
* @name isFalsyArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-falsy-array}
*/
setReadOnly( ns, 'isFalsyArray', __var_97__);

/**
* @name isFinite
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-finite}
*/
setReadOnly( ns, 'isFinite', __var_98__);

/**
* @name isFiniteArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-finite-array}
*/
setReadOnly( ns, 'isFiniteArray', __var_99__);

/**
* @name isFloat32Array
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-float32array}
*/
setReadOnly( ns, 'isFloat32Array', __var_100__);

/**
* @name isFloat32MatrixLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-float32matrix-like}
*/
setReadOnly( ns, 'isFloat32MatrixLike', __var_101__);

/**
* @name isFloat32ndarrayLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-float32ndarray-like}
*/
setReadOnly( ns, 'isFloat32ndarrayLike', __var_102__);

/**
* @name isFloat32VectorLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-float32vector-like}
*/
setReadOnly( ns, 'isFloat32VectorLike', __var_103__);

/**
* @name isFloat64Array
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-float64array}
*/
setReadOnly( ns, 'isFloat64Array', __var_104__);

/**
* @name isFloat64MatrixLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-float64matrix-like}
*/
setReadOnly( ns, 'isFloat64MatrixLike', __var_105__);

/**
* @name isFloat64ndarrayLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-float64ndarray-like}
*/
setReadOnly( ns, 'isFloat64ndarrayLike', __var_106__);

/**
* @name isFloat64VectorLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-float64vector-like}
*/
setReadOnly( ns, 'isFloat64VectorLike', __var_107__);

/**
* @name isFunction
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-function}
*/
setReadOnly( ns, 'isFunction', __var_108__);

/**
* @name isFunctionArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-function-array}
*/
setReadOnly( ns, 'isFunctionArray', __var_109__);

/**
* @name isGeneratorObject
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-generator-object}
*/
setReadOnly( ns, 'isGeneratorObject', __var_110__);

/**
* @name isGeneratorObjectLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-generator-object-like}
*/
setReadOnly( ns, 'isGeneratorObjectLike', __var_111__);

/**
* @name isgzipBuffer
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-gzip-buffer}
*/
setReadOnly( ns, 'isgzipBuffer', __var_112__);

/**
* @name isHexString
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-hex-string}
*/
setReadOnly( ns, 'isHexString', __var_113__);

/**
* @name isInfinite
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-infinite}
*/
setReadOnly( ns, 'isInfinite', __var_114__);

/**
* @name isInheritedProperty
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-inherited-property}
*/
setReadOnly( ns, 'isInheritedProperty', __var_115__);

/**
* @name isInt8Array
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-int8array}
*/
setReadOnly( ns, 'isInt8Array', __var_116__);

/**
* @name isInt16Array
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-int16array}
*/
setReadOnly( ns, 'isInt16Array', __var_117__);

/**
* @name isInt32Array
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-int32array}
*/
setReadOnly( ns, 'isInt32Array', __var_118__);

/**
* @name isInteger
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-integer}
*/
setReadOnly( ns, 'isInteger', __var_119__);

/**
* @name isIntegerArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-integer-array}
*/
setReadOnly( ns, 'isIntegerArray', __var_120__);

/**
* @name isIterableLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-iterable-like}
*/
setReadOnly( ns, 'isIterableLike', __var_121__);

/**
* @name isIteratorLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-iterator-like}
*/
setReadOnly( ns, 'isIteratorLike', __var_122__);

/**
* @name isJSON
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-json}
*/
setReadOnly( ns, 'isJSON', __var_123__);

/**
* @name isLeapYear
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-leap-year}
*/
setReadOnly( ns, 'isLeapYear', __var_124__);

/**
* @name IS_LITTLE_ENDIAN
* @memberof ns
* @readonly
* @type {boolean}
* @see {@link module:@stdlib/assert/is-little-endian}
*/
setReadOnly( ns, 'IS_LITTLE_ENDIAN', __var_125__);

/**
* @name isLowercase
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-lowercase}
*/
setReadOnly( ns, 'isLowercase', __var_126__);

/**
* @name isMatrixLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-matrix-like}
*/
setReadOnly( ns, 'isMatrixLike', __var_127__);

/**
* @name isMethod
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-method}
*/
setReadOnly( ns, 'isMethod', __var_128__);

/**
* @name isMethodIn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-method-in}
*/
setReadOnly( ns, 'isMethodIn', __var_129__);

/**
* @name isNamedTypedTupleLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-named-typed-tuple-like}
*/
setReadOnly( ns, 'isNamedTypedTupleLike', __var_130__);

/**
* @name isnan
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nan}
*/
setReadOnly( ns, 'isnan', __var_131__);

/**
* @name isNaNArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nan-array}
*/
setReadOnly( ns, 'isNaNArray', __var_132__);

/**
* @name isNativeFunction
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-native-function}
*/
setReadOnly( ns, 'isNativeFunction', __var_133__);

/**
* @name isndarrayLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-ndarray-like}
*/
setReadOnly( ns, 'isndarrayLike', __var_134__);

/**
* @name isNegativeInteger
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-negative-integer}
*/
setReadOnly( ns, 'isNegativeInteger', __var_135__);

/**
* @name isNegativeIntegerArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-negative-integer-array}
*/
setReadOnly( ns, 'isNegativeIntegerArray', __var_136__);

/**
* @name isNegativeNumber
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-negative-number}
*/
setReadOnly( ns, 'isNegativeNumber', __var_137__);

/**
* @name isNegativeNumberArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-negative-number-array}
*/
setReadOnly( ns, 'isNegativeNumberArray', __var_138__);

/**
* @name isNegativeZero
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-negative-zero}
*/
setReadOnly( ns, 'isNegativeZero', __var_139__);

/**
* @name IS_NODE
* @memberof ns
* @readonly
* @type {boolean}
* @see {@link module:@stdlib/assert/is-node}
*/
setReadOnly( ns, 'IS_NODE', __var_140__);

/**
* @name isNodeBuiltin
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-node-builtin}
*/
setReadOnly( ns, 'isNodeBuiltin', __var_141__);

/**
* @name isNodeDuplexStreamLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-node-duplex-stream-like}
*/
setReadOnly( ns, 'isNodeDuplexStreamLike', __var_142__);

/**
* @name isNodeReadableStreamLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-node-readable-stream-like}
*/
setReadOnly( ns, 'isNodeReadableStreamLike', __var_143__);

/**
* @name isNodeREPL
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-node-repl}
*/
setReadOnly( ns, 'isNodeREPL', __var_144__);

/**
* @name isNodeStreamLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-node-stream-like}
*/
setReadOnly( ns, 'isNodeStreamLike', __var_145__);

/**
* @name isNodeTransformStreamLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-node-transform-stream-like}
*/
setReadOnly( ns, 'isNodeTransformStreamLike', __var_146__);

/**
* @name isNodeWritableStreamLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-node-writable-stream-like}
*/
setReadOnly( ns, 'isNodeWritableStreamLike', __var_147__);

/**
* @name isNonConfigurableProperty
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nonconfigurable-property}
*/
setReadOnly( ns, 'isNonConfigurableProperty', __var_148__);

/**
* @name isNonConfigurablePropertyIn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nonconfigurable-property-in}
*/
setReadOnly( ns, 'isNonConfigurablePropertyIn', __var_149__);

/**
* @name isNonEnumerableProperty
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nonenumerable-property}
*/
setReadOnly( ns, 'isNonEnumerableProperty', __var_150__);

/**
* @name isNonEnumerablePropertyIn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nonenumerable-property-in}
*/
setReadOnly( ns, 'isNonEnumerablePropertyIn', __var_151__);

/**
* @name isNonNegativeInteger
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nonnegative-integer}
*/
setReadOnly( ns, 'isNonNegativeInteger', __var_152__);

/**
* @name isNonNegativeIntegerArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nonnegative-integer-array}
*/
setReadOnly( ns, 'isNonNegativeIntegerArray', __var_153__);

/**
* @name isNonNegativeNumber
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nonnegative-number}
*/
setReadOnly( ns, 'isNonNegativeNumber', __var_154__);

/**
* @name isNonNegativeNumberArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nonnegative-number-array}
*/
setReadOnly( ns, 'isNonNegativeNumberArray', __var_155__);

/**
* @name isNonPositiveInteger
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nonpositive-integer}
*/
setReadOnly( ns, 'isNonPositiveInteger', __var_156__);

/**
* @name isNonPositiveIntegerArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nonpositive-integer-array}
*/
setReadOnly( ns, 'isNonPositiveIntegerArray', __var_157__);

/**
* @name isNonPositiveNumber
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nonpositive-number}
*/
setReadOnly( ns, 'isNonPositiveNumber', __var_158__);

/**
* @name isNonPositiveNumberArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nonpositive-number-array}
*/
setReadOnly( ns, 'isNonPositiveNumberArray', __var_159__);

/**
* @name isNonSymmetricMatrix
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-nonsymmetric-matrix}
*/
setReadOnly( ns, 'isNonSymmetricMatrix', __var_160__);

/**
* @name isNull
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-null}
*/
setReadOnly( ns, 'isNull', __var_161__);

/**
* @name isNullArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-null-array}
*/
setReadOnly( ns, 'isNullArray', __var_162__);

/**
* @name isNumber
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-number}
*/
setReadOnly( ns, 'isNumber', __var_163__);

/**
* @name isNumberArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-number-array}
*/
setReadOnly( ns, 'isNumberArray', __var_164__);

/**
* @name isNumericArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-numeric-array}
*/
setReadOnly( ns, 'isNumericArray', __var_165__);

/**
* @name isObject
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-object}
*/
setReadOnly( ns, 'isObject', __var_166__);

/**
* @name isObjectArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-object-array}
*/
setReadOnly( ns, 'isObjectArray', __var_167__);

/**
* @name isObjectLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-object-like}
*/
setReadOnly( ns, 'isObjectLike', __var_168__);

/**
* @name isOdd
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-odd}
*/
setReadOnly( ns, 'isOdd', __var_169__);

/**
* @name isPersymmetricMatrix
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-persymmetric-matrix}
*/
setReadOnly( ns, 'isPersymmetricMatrix', __var_170__);

/**
* @name isPlainObject
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-plain-object}
*/
setReadOnly( ns, 'isPlainObject', __var_171__);

/**
* @name isPlainObjectArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-plain-object-array}
*/
setReadOnly( ns, 'isPlainObjectArray', __var_172__);

/**
* @name isPositiveInteger
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-positive-integer}
*/
setReadOnly( ns, 'isPositiveInteger', __var_173__);

/**
* @name isPositiveIntegerArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-positive-integer-array}
*/
setReadOnly( ns, 'isPositiveIntegerArray', __var_174__);

/**
* @name isPositiveNumber
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-positive-number}
*/
setReadOnly( ns, 'isPositiveNumber', __var_175__);

/**
* @name isPositiveNumberArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-positive-number-array}
*/
setReadOnly( ns, 'isPositiveNumberArray', __var_176__);

/**
* @name isPositiveZero
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-positive-zero}
*/
setReadOnly( ns, 'isPositiveZero', __var_177__);

/**
* @name isPrime
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-prime}
*/
setReadOnly( ns, 'isPrime', __var_178__);

/**
* @name isPrimitive
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-primitive}
*/
setReadOnly( ns, 'isPrimitive', __var_179__);

/**
* @name isPrimitiveArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-primitive-array}
*/
setReadOnly( ns, 'isPrimitiveArray', __var_180__);

/**
* @name isPRNGLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-prng-like}
*/
setReadOnly( ns, 'isPRNGLike', __var_181__);

/**
* @name isProbability
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-probability}
*/
setReadOnly( ns, 'isProbability', __var_182__);

/**
* @name isProbabilityArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-probability-array}
*/
setReadOnly( ns, 'isProbabilityArray', __var_183__);

/**
* @name isPrototypeOf
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-prototype-of}
*/
setReadOnly( ns, 'isPrototypeOf', __var_184__);

/**
* @name isRangeError
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-range-error}
*/
setReadOnly( ns, 'isRangeError', __var_185__);

/**
* @name isReadOnlyProperty
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-read-only-property}
*/
setReadOnly( ns, 'isReadOnlyProperty', __var_186__);

/**
* @name isReadOnlyPropertyIn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-read-only-property-in}
*/
setReadOnly( ns, 'isReadOnlyPropertyIn', __var_187__);

/**
* @name isReadWriteProperty
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-read-write-property}
*/
setReadOnly( ns, 'isReadWriteProperty', __var_188__);

/**
* @name isReadWritePropertyIn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-read-write-property-in}
*/
setReadOnly( ns, 'isReadWritePropertyIn', __var_189__);

/**
* @name isReadableProperty
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-readable-property}
*/
setReadOnly( ns, 'isReadableProperty', __var_190__);

/**
* @name isReadablePropertyIn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-readable-property-in}
*/
setReadOnly( ns, 'isReadablePropertyIn', __var_191__);

/**
* @name isReferenceError
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-reference-error}
*/
setReadOnly( ns, 'isReferenceError', __var_192__);

/**
* @name isRegExp
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-regexp}
*/
setReadOnly( ns, 'isRegExp', __var_193__);

/**
* @name isRegExpString
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-regexp-string}
*/
setReadOnly( ns, 'isRegExpString', __var_194__);

/**
* @name isRelativePath
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-relative-path}
*/
setReadOnly( ns, 'isRelativePath', __var_195__);

/**
* @name isSafeInteger
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-safe-integer}
*/
setReadOnly( ns, 'isSafeInteger', __var_196__);

/**
* @name isSafeIntegerArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-safe-integer-array}
*/
setReadOnly( ns, 'isSafeIntegerArray', __var_197__);

/**
* @name isSameValue
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-same-value}
*/
setReadOnly( ns, 'isSameValue', __var_198__);

/**
* @name isSameValueZero
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-same-value-zero}
*/
setReadOnly( ns, 'isSameValueZero', __var_199__);

/**
* @name isSharedArrayBuffer
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-sharedarraybuffer}
*/
setReadOnly( ns, 'isSharedArrayBuffer', __var_200__);

/**
* @name isSkewCentrosymmetricMatrix
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-skew-centrosymmetric-matrix}
*/
setReadOnly( ns, 'isSkewCentrosymmetricMatrix', __var_201__);

/**
* @name isSkewPersymmetricMatrix
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-skew-persymmetric-matrix}
*/
setReadOnly( ns, 'isSkewPersymmetricMatrix', __var_202__);

/**
* @name isSkewSymmetricMatrix
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-skew-symmetric-matrix}
*/
setReadOnly( ns, 'isSkewSymmetricMatrix', __var_203__);

/**
* @name isSquareMatrix
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-square-matrix}
*/
setReadOnly( ns, 'isSquareMatrix', __var_204__);

/**
* @name isSquareNumber
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-square-number}
*/
setReadOnly( ns, 'isSquareNumber', __var_205__);

/**
* @name isSquareTriangularNumber
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-square-triangular-number}
*/
setReadOnly( ns, 'isSquareTriangularNumber', __var_206__);

/**
* @name isStrictEqual
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-strict-equal}
*/
setReadOnly( ns, 'isStrictEqual', __var_207__);

/**
* @name isString
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-string}
*/
setReadOnly( ns, 'isString', __var_208__);

/**
* @name isStringArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-string-array}
*/
setReadOnly( ns, 'isStringArray', __var_209__);

/**
* @name isSymbol
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-symbol}
*/
setReadOnly( ns, 'isSymbol', __var_210__);

/**
* @name isSymbolArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-symbol-array}
*/
setReadOnly( ns, 'isSymbolArray', __var_211__);

/**
* @name isSymmetricMatrix
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-symmetric-matrix}
*/
setReadOnly( ns, 'isSymmetricMatrix', __var_212__);

/**
* @name isSyntaxError
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-syntax-error}
*/
setReadOnly( ns, 'isSyntaxError', __var_213__);

/**
* @name isTriangularNumber
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-triangular-number}
*/
setReadOnly( ns, 'isTriangularNumber', __var_214__);

/**
* @name isTruthy
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-truthy}
*/
setReadOnly( ns, 'isTruthy', __var_215__);

/**
* @name isTruthyArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-truthy-array}
*/
setReadOnly( ns, 'isTruthyArray', __var_216__);

/**
* @name isTypeError
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-type-error}
*/
setReadOnly( ns, 'isTypeError', __var_217__);

/**
* @name isTypedArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-typed-array}
*/
setReadOnly( ns, 'isTypedArray', __var_218__);

/**
* @name isTypedArrayLength
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-typed-array-length}
*/
setReadOnly( ns, 'isTypedArrayLength', __var_219__);

/**
* @name isTypedArrayLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-typed-array-like}
*/
setReadOnly( ns, 'isTypedArrayLike', __var_220__);

/**
* @name isUint8Array
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-uint8array}
*/
setReadOnly( ns, 'isUint8Array', __var_221__);

/**
* @name isUint8ClampedArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-uint8clampedarray}
*/
setReadOnly( ns, 'isUint8ClampedArray', __var_222__);

/**
* @name isUint16Array
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-uint16array}
*/
setReadOnly( ns, 'isUint16Array', __var_223__);

/**
* @name isUint32Array
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-uint32array}
*/
setReadOnly( ns, 'isUint32Array', __var_224__);

/**
* @name isUNCPath
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-unc-path}
*/
setReadOnly( ns, 'isUNCPath', __var_225__);

/**
* @name isUndefined
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-undefined}
*/
setReadOnly( ns, 'isUndefined', __var_226__);

/**
* @name isUndefinedOrNull
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-undefined-or-null}
*/
setReadOnly( ns, 'isUndefinedOrNull', __var_227__);

/**
* @name isUnityProbabilityArray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-unity-probability-array}
*/
setReadOnly( ns, 'isUnityProbabilityArray', __var_228__);

/**
* @name isUppercase
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-uppercase}
*/
setReadOnly( ns, 'isUppercase', __var_229__);

/**
* @name isURI
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-uri}
*/
setReadOnly( ns, 'isURI', __var_230__);

/**
* @name isURIError
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-uri-error}
*/
setReadOnly( ns, 'isURIError', __var_231__);

/**
* @name isVectorLike
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-vector-like}
*/
setReadOnly( ns, 'isVectorLike', __var_232__);

/**
* @name IS_WEB_WORKER
* @memberof ns
* @readonly
* @type {boolean}
* @see {@link module:@stdlib/assert/is-web-worker}
*/
setReadOnly( ns, 'IS_WEB_WORKER', __var_233__);

/**
* @name isWhitespace
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-whitespace}
*/
setReadOnly( ns, 'isWhitespace', __var_234__);

/**
* @name IS_WINDOWS
* @memberof ns
* @readonly
* @type {boolean}
* @see {@link module:@stdlib/assert/is-windows}
*/
setReadOnly( ns, 'IS_WINDOWS', __var_235__);

/**
* @name isWritableProperty
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-writable-property}
*/
setReadOnly( ns, 'isWritableProperty', __var_236__);

/**
* @name isWritablePropertyIn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-writable-property-in}
*/
setReadOnly( ns, 'isWritablePropertyIn', __var_237__);

/**
* @name isWriteOnlyProperty
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-write-only-property}
*/
setReadOnly( ns, 'isWriteOnlyProperty', __var_238__);

/**
* @name isWriteOnlyPropertyIn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/assert/is-write-only-property-in}
*/
setReadOnly( ns, 'isWriteOnlyPropertyIn', __var_239__);


// EXPORTS //
export default ns;

export { __var_1__ as contains, __var_2__ as deepEqual, __var_3__ as deepHasOwnProp, __var_4__ as deepHasProp, __var_5__ as hasArrayBufferSupport, __var_6__ as hasAsyncAwaitSupport, __var_7__ as hasAsyncIteratorSymbolSupport, __var_8__ as hasClassSupport, __var_9__ as hasDefinePropertiesSupport, __var_10__ as hasDefinePropertySupport, __var_11__ as hasFloat32ArraySupport, __var_12__ as hasFloat64ArraySupport, __var_13__ as hasFunctionNameSupport, __var_14__ as hasGeneratorSupport, __var_15__ as hasGlobalThisSupport, __var_16__ as hasInt8ArraySupport, __var_17__ as hasInt16ArraySupport, __var_18__ as hasInt32ArraySupport, __var_19__ as hasIteratorSymbolSupport, __var_20__ as hasMapSupport, __var_21__ as hasNodeBufferSupport, __var_22__ as hasOwnProp, __var_23__ as hasProp, __var_24__ as hasProxySupport, __var_25__ as hasSetSupport, __var_26__ as hasSharedArrayBufferSupport, __var_27__ as hasSymbolSupport, __var_28__ as hasToStringTagSupport, __var_29__ as hasUint8ArraySupport, __var_30__ as hasUint8ClampedArraySupport, __var_31__ as hasUint16ArraySupport, __var_32__ as hasUint32ArraySupport, __var_33__ as hasUTF16SurrogatePairAt, __var_34__ as hasWebAssemblySupport, __var_35__ as hasWeakMapSupport, __var_36__ as hasWeakSetSupport, __var_37__ as instanceOf, __var_38__ as isAbsolutePath, __var_39__ as isAccessorProperty, __var_40__ as isAccessorPropertyIn, __var_41__ as isAlphagram, __var_42__ as isAlphaNumeric, __var_43__ as isAnagram, __var_44__ as isArguments, __var_45__ as isArray, __var_46__ as isArrayArray, __var_47__ as isArrayLength, __var_48__ as isArrayLike, __var_49__ as isArrayLikeObject, __var_50__ as isArrayBuffer, __var_51__ as isASCII, __var_52__ as isBetween, __var_53__ as isBetweenArray, __var_54__ as IS_BIG_ENDIAN, __var_55__ as isBinaryString, __var_56__ as isBoolean, __var_57__ as isBooleanArray, __var_58__ as isBoxedPrimitive, __var_59__ as IS_BROWSER, __var_60__ as isBuffer, __var_61__ as isCapitalized, __var_62__ as isCentrosymmetricMatrix, __var_63__ as isCircular, __var_64__ as isCircularArray, __var_65__ as isCircularPlainObject, __var_66__ as isCollection, __var_67__ as isComplex, __var_68__ as isComplexLike, __var_69__ as isComplexTypedArray, __var_70__ as isComplexTypedArrayLike, __var_71__ as isComplex64, __var_72__ as isComplex64Array, __var_73__ as isComplex128, __var_74__ as isComplex128Array, __var_75__ as isComposite, __var_76__ as isConfigurableProperty, __var_77__ as isConfigurablePropertyIn, __var_78__ as isCubeNumber, __var_79__ as IS_DARWIN, __var_80__ as isDataProperty, __var_81__ as isDataPropertyIn, __var_82__ as isDateObject, __var_83__ as isDigitString, __var_84__ as IS_ELECTRON, __var_85__ as IS_ELECTRON_MAIN, __var_86__ as IS_ELECTRON_RENDERER, __var_87__ as isEmailAddress, __var_88__ as isEmptyArray, __var_89__ as isEmptyObject, __var_90__ as isEmptyString, __var_91__ as isEnumerableProperty, __var_92__ as isEnumerablePropertyIn, __var_93__ as isError, __var_94__ as isEvalError, __var_95__ as isEven, __var_96__ as isFalsy, __var_97__ as isFalsyArray, __var_98__ as isFinite, __var_99__ as isFiniteArray, __var_100__ as isFloat32Array, __var_101__ as isFloat32MatrixLike, __var_102__ as isFloat32ndarrayLike, __var_103__ as isFloat32VectorLike, __var_104__ as isFloat64Array, __var_105__ as isFloat64MatrixLike, __var_106__ as isFloat64ndarrayLike, __var_107__ as isFloat64VectorLike, __var_108__ as isFunction, __var_109__ as isFunctionArray, __var_110__ as isGeneratorObject, __var_111__ as isGeneratorObjectLike, __var_112__ as isgzipBuffer, __var_113__ as isHexString, __var_114__ as isInfinite, __var_115__ as isInheritedProperty, __var_116__ as isInt8Array, __var_117__ as isInt16Array, __var_118__ as isInt32Array, __var_119__ as isInteger, __var_120__ as isIntegerArray, __var_121__ as isIterableLike, __var_122__ as isIteratorLike, __var_123__ as isJSON, __var_124__ as isLeapYear, __var_125__ as IS_LITTLE_ENDIAN, __var_126__ as isLowercase, __var_127__ as isMatrixLike, __var_128__ as isMethod, __var_129__ as isMethodIn, __var_130__ as isNamedTypedTupleLike, __var_131__ as isnan, __var_132__ as isNaNArray, __var_133__ as isNativeFunction, __var_134__ as isndarrayLike, __var_135__ as isNegativeInteger, __var_136__ as isNegativeIntegerArray, __var_137__ as isNegativeNumber, __var_138__ as isNegativeNumberArray, __var_139__ as isNegativeZero, __var_140__ as IS_NODE, __var_141__ as isNodeBuiltin, __var_142__ as isNodeDuplexStreamLike, __var_143__ as isNodeReadableStreamLike, __var_144__ as isNodeREPL, __var_145__ as isNodeStreamLike, __var_146__ as isNodeTransformStreamLike, __var_147__ as isNodeWritableStreamLike, __var_148__ as isNonConfigurableProperty, __var_149__ as isNonConfigurablePropertyIn, __var_150__ as isNonEnumerableProperty, __var_151__ as isNonEnumerablePropertyIn, __var_152__ as isNonNegativeInteger, __var_153__ as isNonNegativeIntegerArray, __var_154__ as isNonNegativeNumber, __var_155__ as isNonNegativeNumberArray, __var_156__ as isNonPositiveInteger, __var_157__ as isNonPositiveIntegerArray, __var_158__ as isNonPositiveNumber, __var_159__ as isNonPositiveNumberArray, __var_160__ as isNonSymmetricMatrix, __var_161__ as isNull, __var_162__ as isNullArray, __var_163__ as isNumber, __var_164__ as isNumberArray, __var_165__ as isNumericArray, __var_166__ as isObject, __var_167__ as isObjectArray, __var_168__ as isObjectLike, __var_169__ as isOdd, __var_170__ as isPersymmetricMatrix, __var_171__ as isPlainObject, __var_172__ as isPlainObjectArray, __var_173__ as isPositiveInteger, __var_174__ as isPositiveIntegerArray, __var_175__ as isPositiveNumber, __var_176__ as isPositiveNumberArray, __var_177__ as isPositiveZero, __var_178__ as isPrime, __var_179__ as isPrimitive, __var_180__ as isPrimitiveArray, __var_181__ as isPRNGLike, __var_182__ as isProbability, __var_183__ as isProbabilityArray, __var_184__ as isPrototypeOf, __var_185__ as isRangeError, __var_186__ as isReadOnlyProperty, __var_187__ as isReadOnlyPropertyIn, __var_188__ as isReadWriteProperty, __var_189__ as isReadWritePropertyIn, __var_190__ as isReadableProperty, __var_191__ as isReadablePropertyIn, __var_192__ as isReferenceError, __var_193__ as isRegExp, __var_194__ as isRegExpString, __var_195__ as isRelativePath, __var_196__ as isSafeInteger, __var_197__ as isSafeIntegerArray, __var_198__ as isSameValue, __var_199__ as isSameValueZero, __var_200__ as isSharedArrayBuffer, __var_201__ as isSkewCentrosymmetricMatrix, __var_202__ as isSkewPersymmetricMatrix, __var_203__ as isSkewSymmetricMatrix, __var_204__ as isSquareMatrix, __var_205__ as isSquareNumber, __var_206__ as isSquareTriangularNumber, __var_207__ as isStrictEqual, __var_208__ as isString, __var_209__ as isStringArray, __var_210__ as isSymbol, __var_211__ as isSymbolArray, __var_212__ as isSymmetricMatrix, __var_213__ as isSyntaxError, __var_214__ as isTriangularNumber, __var_215__ as isTruthy, __var_216__ as isTruthyArray, __var_217__ as isTypeError, __var_218__ as isTypedArray, __var_219__ as isTypedArrayLength, __var_220__ as isTypedArrayLike, __var_221__ as isUint8Array, __var_222__ as isUint8ClampedArray, __var_223__ as isUint16Array, __var_224__ as isUint32Array, __var_225__ as isUNCPath, __var_226__ as isUndefined, __var_227__ as isUndefinedOrNull, __var_228__ as isUnityProbabilityArray, __var_229__ as isUppercase, __var_230__ as isURI, __var_231__ as isURIError, __var_232__ as isVectorLike, __var_233__ as IS_WEB_WORKER, __var_234__ as isWhitespace, __var_235__ as IS_WINDOWS, __var_236__ as isWritableProperty, __var_237__ as isWritablePropertyIn, __var_238__ as isWriteOnlyProperty, __var_239__ as isWriteOnlyPropertyIn};